import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear: number=new Date().getFullYear();

  public lang = '';


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
    ) { }

  ngOnInit(): void {
    this.lang = (this.activatedRoute.snapshot.queryParams['lang'] == undefined) ? 'pt-br' : this.activatedRoute.snapshot.queryParams['lang'];
  }

  // changeLang(){
  //   const htmlElement = this.el.nativeElement.ownerDocument.documentElement;
  //   const langAttribute = htmlElement.getAttribute('lang');
  //   if(langAttribute == 'pt-br'){
  //     htmlElement.setAttribute('lang', 'en');
  //   }else if(langAttribute == 'en'){
  //     htmlElement.setAttribute('lang', 'pt');
  //   }
  // }

  changeLang() {
    // Navigate to the same route with a different lang parameter
    this.lang = this.activatedRoute.snapshot.queryParams['lang'];

    const url = this.router.url.replace(/\?lang=(en|pt-br)/, '');

    if(this.lang == 'en'){
      this.router.navigate([url], { queryParams: { lang: 'pt-br' } });
    }else{
       this.router.navigate([url], { queryParams: { lang:'en' } });
    }
  }

}
